export default function() {
  return {
    accountId: "",
    allUsers: null,
    userEmail: "",
    userName: "",
    summary: null,
  };
}
